<div class="modal-dialog modal-dialog-centered modal-xl">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" i18n>Detalhes do Motivo de Invalidação</h5>
      <button type="button" (click)="onClose()" class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="modal-body label">
      <div class="container">

        <!-- Contrato + Habilitado -->
        <div class="row">
          <div class="col-8">
            <app-input type="text" [isLabel]="true" label="Contrato"
              [textValue]="contract && contract.code + ' - ' + contract.name">
            </app-input>
          </div>
          <div class="col-4">
            <label class="text-label" i18n>Habilitado?</label>
            <div class="custom-control custom-switch">
              <label class="custom-control-label" [ngClass]="{checked: reason.enabled}">
                <input type="checkbox" class="form-control custom-control-input">
              </label>
            </div>
          </div>
        </div>

        <!-- Código, Nome, Código do Cliente, Tipo -->
        <div class="row mt-2">
          <div class="col-3">
            <app-input type="text" [isLabel]="true" label="Código" [textValue]="reason.code"></app-input>
          </div>
          <div class="col-3">
            <app-input type="text" [isLabel]="true" label="Nome" [textValue]="reason.name"></app-input>
          </div>
          <div class="col-3">
            <app-input type="text" [isLabel]="true" label="Código do Cliente"
              [textValue]="reason.clientCode || '-'"></app-input>
          </div>
          <div class="col-3">
            <app-input type="text" [isLabel]="true" label="Tipo" [textValue]="reason.type"></app-input>
          </div>
        </div>

        <!-- Enquadramento (apenas se não for somente passagem) -->
        <div class="row mt-2" *ngIf="showEnquadramento">
          <div class="col-12">
            <label class="text-label" i18n>Enquadramento</label>
            <div>
              <span class="badge badge-fade-info mr-1" *ngFor="let regulation of regulations">
                {{ regulation.shortDescription || regulation.description }}
              </span>
              <span *ngIf="regulations.length === 0" class="text-muted">-</span>
            </div>
          </div>
        </div>

        <!-- Módulos de Utilização -->
        <div class="row mt-3 mb-3">
          <div class="col-12">
            <div class="modules-container p-3">
              <div class="d-flex align-items-center">
                <label class="text-label mr-3 mb-0" i18n>Módulos de Utilização</label>
                <div class="module-option mr-3"
                  [ngClass]="{'module-option--active': applicableModules.includes('violation')}">
                  <span class="module-checkbox">
                    <i class="material-icons" *ngIf="applicableModules.includes('violation')">check_box</i>
                    <i class="material-icons"
                      *ngIf="!applicableModules.includes('violation')">check_box_outline_blank</i>
                  </span>
                  <span class="module-label ml-1">Infração</span>
                  <i class="material-icons module-icon ml-2">info</i>
                </div>
                <div class="module-option" [ngClass]="{'module-option--active': applicableModules.includes('traffic')}">
                  <span class="module-checkbox">
                    <i class="material-icons" *ngIf="applicableModules.includes('traffic')">check_box</i>
                    <i class="material-icons" *ngIf="!applicableModules.includes('traffic')">check_box_outline_blank</i>
                  </span>
                  <span class="module-label ml-1">Passagem</span>
                  <i class="material-icons module-icon ml-2">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px"
                      fill="#1f1f1f">
                      <path
                        d="M80-80q-17 0-28.5-11.5T40-120v-320l85-203q7-17 22-27t33-10h360q18 0 33 10t22 27l85 203v320q0 17-11.5 28.5T640-80h-40q-17 0-28.5-11.5T560-120v-40H160v40q0 17-11.5 28.5T120-80H80Zm72-440h415l-33-80H186l-34 80Zm-32 280h480v-200H120v200Zm142.5-57.5Q280-315 280-340t-17.5-42.5Q245-400 220-400t-42.5 17.5Q160-365 160-340t17.5 42.5Q195-280 220-280t42.5-17.5Zm280 0Q560-315 560-340t-17.5-42.5Q525-400 500-400t-42.5 17.5Q440-365 440-340t17.5 42.5Q475-280 500-280t42.5-17.5ZM720-200v-344l-73-176H227l18-43q7-17 22-27t33-10h360q18 0 33 10t22 27l85 203v320q0 17-11.5 28.5T760-200h-40Zm120-120v-344l-73-176H347l18-43q7-17 22-27t33-10h360q18 0 33 10t22 27l85 203v320q0 17-11.5 28.5T880-320h-40Zm-480-20Z" />
                    </svg>
                  </i>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Telas (apenas se não for somente passagem) -->
        <div *ngIf="showTelas">
          <div class="col-12">
            <form [formGroup]="reasonForm">
              <div class="card pb-2">
                <div class="card-header" style="cursor: pointer;" (click)="toggleCollapse(showArea)">
                  <h5 class="mb-0">
                    <div class="col-md-12 btn btn-link">
                      <div class="row">
                        <div class="col-md-11">
                          <p class="text-left" i18n>Exibir este motivo de invalidação nas telas:</p>
                        </div>
                        <div class="col-md-1">
                          <p class="mb-1 text-right">
                            <i class="material-icons">{{ showArea ? 'expand_less' : 'expand_more' }}</i>
                          </p>
                        </div>
                      </div>
                    </div>
                  </h5>
                </div>
                <div *ngIf="showArea">
                  <div class="card-body pb-2">
                    <div class="row">
                      <div class="col">
                        <label i18n>Cadastro Básico</label>
                        <div class="row mt-1">
                          <div class="col-auto">
                            <mat-checkbox color="primary" formControlName="exemptPeriod" i18n (click)="false">Período
                              Isento</mat-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-md-12">
                        <label i18n>Pré-Processamento</label>
                        <div class="row mt-1">
                          <div class="col-md-4">
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="quarantine"
                                  i18n>Quarentena</mat-checkbox>
                              </div>
                            </div>
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="triage"
                                  i18n>Triagem</mat-checkbox>
                              </div>
                            </div>
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="typing"
                                  i18n>Digitação</mat-checkbox>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="verifyValid"
                                  i18n>Verificação de Válidas</mat-checkbox>
                              </div>
                            </div>
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="verifyInvalid"
                                  i18n>Verificação de Inválidas</mat-checkbox>
                              </div>
                            </div>
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="validate"
                                  i18n>Validação</mat-checkbox>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="audit"
                                  i18n>Auditoria</mat-checkbox>
                              </div>
                            </div>
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="serialNumberConfig"
                                  i18n>Gerenciar Série</mat-checkbox>
                              </div>
                            </div>
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="preProcessConfig"
                                  i18n>Configuração de Pré-Processamento</mat-checkbox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-md-12">
                        <label i18n>eCS Spy</label>
                        <div class="row mt-1">
                          <div class="col-md-4">
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="verifyCFTV"
                                  i18n>Verificação Infrações CFTV</mat-checkbox>
                              </div>
                            </div>
                            <div class="row mt-1">
                              <div class="col-auto">
                                <mat-checkbox color="primary" (click)="false" formControlName="validateCFTV"
                                  i18n>Validação Infrações CFTV</mat-checkbox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
